import { z } from 'zod'
import { LearningQuizQuestionType } from '@/core/domain/resources/enums/LearningQuizQuestion.ts'

export const ContentItemSchema = z.object({
  type: z.string(),
  value: z.string()
})

// Base answer schema
const QuizQuestionBaseAnswerSchema = z.object({
  type: z.nativeEnum(LearningQuizQuestionType.Values)
})

// MCQ/UCQ Answer schema
export const QuizQuestionAnswerSingleChoiceSchema = QuizQuestionBaseAnswerSchema.extend({
  type: z.literal(LearningQuizQuestionType.Values.SINGLE_CHOICE),
  label: z.string(),
  isCorrect: z.boolean()
}).strict()

export const QuizQuestionAnswerMultipleChoiceSchema = QuizQuestionBaseAnswerSchema.extend({
  type: z.literal(LearningQuizQuestionType.Values.MULTIPLE_CHOICE),
  label: z.string(),
  isCorrect: z.boolean()
}).strict()

// True/False Answer schema
export const QuizQuestionAnswerTrueFalseSchema = QuizQuestionBaseAnswerSchema.extend({
  type: z.literal(LearningQuizQuestionType.Values.TRUE_FALSE),
  label: z.string(),
  isCorrect: z.boolean()
}).strict()

export const QuizQuestionAnswerMatchingSchema = QuizQuestionBaseAnswerSchema.extend({
  type: z.literal(LearningQuizQuestionType.Values.MATCHING),
  left: ContentItemSchema,
  right: ContentItemSchema
}).strict()

export const QuizQuestionAnswerSequencingSchema = QuizQuestionBaseAnswerSchema.extend({
  type: z.literal(LearningQuizQuestionType.Values.SEQUENCING),
  data: ContentItemSchema,
  order: z.number()
}).strict()

export const QuestionAnswerSchema = z.discriminatedUnion('type', [
  QuizQuestionAnswerSingleChoiceSchema,
  QuizQuestionAnswerMultipleChoiceSchema,
  QuizQuestionAnswerTrueFalseSchema,
  QuizQuestionAnswerMatchingSchema,
  QuizQuestionAnswerSequencingSchema
])

export type QuizQuestionAnswerEntity = z.infer<typeof QuestionAnswerSchema>
export type QuizQuestionAnswerSingleChoiceEntity = z.infer<
  typeof QuizQuestionAnswerSingleChoiceSchema
>
export type QuizQuestionAnswerMultipleChoiceEntity = z.infer<
  typeof QuizQuestionAnswerMultipleChoiceSchema
>
export type QuizQuestionAnswerTrueFalseEntity = z.infer<typeof QuizQuestionAnswerTrueFalseSchema>
export type QuizQuestionAnswerMatchingEntity = z.infer<typeof QuizQuestionAnswerMatchingSchema>
export type QuizQuestionAnswerSequencingEntity = z.infer<typeof QuizQuestionAnswerSequencingSchema>
export type ContentItemEntity = z.infer<typeof ContentItemSchema>
